<div class="container">
  <h2>Explore forums</h2>
  <div id="forum-list">
    @if (isLoading) {
      <app-loading class="loading"></app-loading>
    }
    @for (forum of forums; track forum) {
      <app-home-forum-item [forum]="forum"></app-home-forum-item>
    }
  </div>
</div>
